/**
 * The count under a writing box, against its limit (#107): „1234 / 6000“,
 * bottom right, as social media shows it. The box carries it in its
 * aria-describedby, so it is read on focus rather than announced on every
 * keystroke.
 *
 * It counts what the server counts: the string's length, the same measure as
 * the Zod `.max()` that enforces the limit.
 */

import { useI18n } from '../i18n/index.tsx'

export function CharacterCount({ id, count, limit }: { id: string; count: number; limit: number }) {
  const { locale } = useI18n()
  const number = new Intl.NumberFormat(locale === 'bg' ? 'bg-BG' : 'en-GB')
  return (
    <p id={id} className={count > limit ? 'field__count field__count--over' : 'field__count'}>
      {/* Two numbers and a slash: the same in both languages, so not in the i18n tables. */}
      {number.format(count)} / {number.format(limit)}
    </p>
  )
}
